import React from 'react';
import classNames from 'classnames';
import cls from './ItemResizer.module.css';
import { useSelector } from 'react-redux';

export const ItemResizer = ({ onResize, onStageChange, classes }) => {
    const { activeTab } = useSelector((state) => state.gantReducer);

    const handleMouseMove = (event) => {
        onResize(event.movementX);
    };
    const handleMouseUp = (event) => {
        onStageChange();
        window.removeEventListener('mousemove', handleMouseMove);
        window.removeEventListener('mouseup', handleMouseUp);
    };

    return (
        <div
            className={classNames(cls.Resizer, [classes], {
                [cls.smallResizer]: activeTab !== 'day',
            })}
            onMouseDown={(e) => {
                e.stopPropagation();
                window.addEventListener('mousemove', handleMouseMove);

                window.addEventListener('mouseup', handleMouseUp);
            }}
        >
            <svg
                style={{ background: '#E6E6E6' }}
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3 1.5C3.27614 1.5 3.5 1.72386 3.5 2V10C3.5 10.2761 3.27614 10.5 3 10.5C2.72386 10.5 2.5 10.2761 2.5 10V2C2.5 1.72386 2.72386 1.5 3 1.5Z"
                    fill="#757575"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6 1.5C6.27615 1.5 6.5 1.72386 6.5 2V10C6.5 10.2761 6.27615 10.5 6 10.5C5.72385 10.5 5.5 10.2761 5.5 10V2C5.5 1.72386 5.72385 1.5 6 1.5Z"
                    fill="#757575"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9 1.5C9.27615 1.5 9.5 1.72386 9.5 2V10C9.5 10.2761 9.27615 10.5 9 10.5C8.72385 10.5 8.5 10.2761 8.5 10V2C8.5 1.72386 8.72385 1.5 9 1.5Z"
                    fill="#757575"
                />
            </svg>
        </div>
    );
};
